
// TODO: remove when using es2024 target as Object / Map have this on them
export function groupBy<K extends string | number, T extends object>(objects: T[], fn: (o: T) => K): Record<K, T[]> {
  const ret = {} as Record<K, T[]>;
  if (!objects || !fn) {
    return ret;
  }

  for (const object of objects) {
    const key = fn(object);
    if (!ret[key]) {
      ret[key] = [];
    }
    ret[key].push(object);
  }

  return ret;
}
